import { render, staticRenderFns } from "./CustomerCarForm.vue?vue&type=template&id=6054b14d"
import script from "./CustomerCarForm.vue?vue&type=script&lang=js"
export * from "./CustomerCarForm.vue?vue&type=script&lang=js"
import style0 from "./CustomerCarForm.vue?vue&type=style&index=0&id=6054b14d&prod&lang=scss"


/* normalize component */
import normalizer from "!./node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports